export default __webpack_public_path__ + "static/media/01_Arch_jbd.72e37143.jpg";